import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientAssessmentControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useDefaultPatientAssessmentList = (): useBaseContent<OptionData> => {
  return useQuery({
    queryKey: ["all-default-screening-assessment"],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientAssessmentControllerApi(getConfigObject())
        .getDefaultAssessments(getXtenantId())
        .then((res) => res?.data),
  });
};
